// src/contexts/UserContext.jsx
import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types"; // חובה לייבא
import { io } from "socket.io-client";
import { serverUrl } from "utils/utils";
import axios from "axios";
import { userObject } from "content/userObject";

// קונטקסט ברירת מחדל
const UserContext = createContext({
  isLoggedIn: false,
  token: "",
  setIsLoggedIn: () => {},
  setToken: () => {},
  userDetails: userObject,
});

// פרוביידר
export const UserProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState("");
  const [userDetails, setUserDetails] = useState({});

  const tokenFromStorage = localStorage.getItem("userToken");
  useEffect(() => {
    if (tokenFromStorage && tokenFromStorage.length > 2) {
      setIsLoggedIn(true);
      setToken(tokenFromStorage);
    } else {
      setToken(``);
      setIsLoggedIn(false);
    }
  }, [tokenFromStorage]);
  useEffect(() => {
    const fetchUserDetails = async () => {
      if (token.length > 5 && isLoggedIn) {
        try {
          const response = await axios.get(`${serverUrl}/user/getMyUserDetails`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setUserDetails(response.data);
        } catch (error) {
          console.error("Error fetching user details:", error.response?.data || error.message);
        }
      }
    };

    fetchUserDetails();
  }, [token, isLoggedIn]);

  useEffect(() => {
    if (token.length > 5 && isLoggedIn && typeof userDetails === "object" && "_id" in userDetails) {
      const socket1 = io(serverUrl, {
        auth: {
          token: `Bearer ${token}`,
          userId: userDetails._id,
        },
        transports: ["websocket"],
      });

      socket1.on("user-details-update", (updatedUserDetails) => {
        console.log("User details updated via Socket:");
        setUserDetails(updatedUserDetails);
      });

      return () => {
        socket1.disconnect();
        socket2.disconnect();
      };
    }
  }, [token, isLoggedIn, userDetails._id]);

  return (
    <UserContext.Provider value={{ isLoggedIn, token, setIsLoggedIn, setToken, userDetails }}>
      {children}
    </UserContext.Provider>
  );
};

// ✅ כאן צריך להגדיר את propTypes – **מחוץ** לפונקציה
UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// שימוש בקונטקסט
export const useUserContext = () => useContext(UserContext);
